<template>
	<!-- eslint-disable-next-line vue/no-v-html -->
	<div ref="htmlTarget" v-html="html" />
</template>

<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue';
import { executeScriptsInElement } from '@/lib/monolith';

/**
 * Render some HTML from the monolith into the DOM and execute the JavaScript in
 * it.
 */
const props = defineProps<{
	html?: string;
}>();

const htmlTarget = ref<HTMLDivElement | null>(null);

watch(
	() => props.html,
	async () => {
		await nextTick();

		if (htmlTarget.value) {
			executeScriptsInElement(htmlTarget.value);
		}
	},
	{ immediate: true }
);
</script>
